
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/share/user",
      function () {
        return require("private-next-pages/share/user/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/share/user"])
      });
    }
  